/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import {axiosInstance} from '../axiosInstance'
const getAllDevice = param => {
    return axiosInstance.post(`/api/gcadmin/v1/device/getAll`,param).then(res => res.data)
}
const createDevice = (app) => {
    return axiosInstance.post(`/api/gcadmin/v1/device/create`,app).then(res => res.data)
}
const editDevice = (app) => {
    return axiosInstance.post(`/api/gcadmin/v1/device/update`,app).then(res => res.data)
}
const getDeviceHistory = param => {
    return axiosInstance.post(`/api/gcadmin/v1/device/get-history`,param).then(res => res.data)
}
export {
    getAllDevice,
    createDevice,
    editDevice,
    getDeviceHistory
}
